import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  loading: false,
  error: false,
  submitted: false,
  errorMessage: "",
};
const submitContactInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_CONTACT_INFORMATION_STARTED:
      return updateObject(state, {
        loading: true,
        error: false,
        submitted: false,
        errorMessage: "",
      });
    case actionTypes.SUBMIT_CONTACT_INFORMATION_SUCCESS:
      return updateObject(state, {
        loading: false,
        error: false,
        submitted: true,
        errorMessage: "",
      });
    case actionTypes.SUBMIT_CONTACT_INFORMATION_FAILED:
      return updateObject(state, {
        loading: false,
        error: true,
        submitted: false,
        errorMessage: action.errorMessage,
      });
    case actionTypes.RESET_SUBMIT_CONTACT_INFORMATION:
      return updateObject(state, {
        loading: false,
        error: false,
        submitted: false,
        errorMessage: "",
      });
    default:
      return state;
  }
};

export default submitContactInformationReducer;
